/// <reference path="../../typings/index.d.ts" />
/// <reference path="apimodel.d.ts" />
/// <reference path="common/lodashmixins.ts" />
/// <reference path="common/app.common.module.ts" />
/// <reference path="HiLO/app.HiLO.module.ts" />
/// <reference path="HiLO/directives/app.HiLO.directives.module.ts" />
/// <reference path="templates.ts" />

((() => {
	'use strict';

	angular
		.module('app', [

			//Third party dependencies
			'angular-google-analytics',
			'chart.js',
			'angular-busy',
			'duScroll',
			'jcs-autoValidate',
			'ngAnimate',
			'ngSanitize',
			'ngStorage',
			'tableSort',
			'ui.bootstrap',
			'ui.mask',
			'ui.router',
			'ngFileUpload',
			'ngCookies',
			'monospaced.elastic',

			//Application modules
			'app.templates',
			'app.common',
			'app.hilo'
		]);

})());